import { Component } from '@angular/core';

@Component({
  selector: 'payment',
  template: `
		<ui-view></ui-view>
	`
})
export class PaymentComponent {
}